const defaultSlider = (container, options = 0) => {

    const $container = $(container);

    if(options === 0) {
        options = {
            dots: true,
            infinite: true,
            slidesToShow: 1,
            autoplay: true,
            autoplaySpeed: 5000,
            customPaging: function(slider, i) {
                return '<div style="background-image: url(/assets/front/img/pages/home/slider/foto/' + (i + 1) + '.jpg)"></div>';
            },
            responsive: {

                992 : {
                    items: 3
                },

                768 : {
                    items: 2
                },

                0 : {
                    items: 1
                }
            }
        }
    }


    $container.slick(options)

};

export default defaultSlider;
